import React, { useState } from "react";
import { colors } from "../../constants/colors";
import { MainButton } from "../Buttons/MainButton/MainButton";
import { Modal, Form, Input } from 'antd';
import serviceMail from '../../services/sendmail'
import { toast } from "react-toastify";
export const SignUp = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  function handleSendMail(Subject, Message, from, to) {
    const data = {
      from,
      to,
      subject: Subject,
      html: Message,
    };
    serviceMail.sendMail(data);
  }

  function handleSubmit() {
    const values = form.getFieldsValue()
    const { email, name, introduction } = values
    const subject = `${name} Want to connect GenC Health`;
    const content = `
    <div>Name: ${name}</div>
    <div Email: ${email}</div>
    <div>Message: ${introduction}</div>
    <div>The Genc team</div>
    <a href="https://www.genchealth.com/" tagert="_blank">https://www.genchealth.com/</a>
    `;
    toast.success(("Your request send successfully"))

    handleSendMail(subject, content, email, ['philiptranp@gmail.com', 'support@angelo.network', 'cuongseven789@gmail.com'])

    form.resetFields()
    setIsModalVisible(false)
  }

  return (
    <section
      data-aos="zoom-in"
      className="sign-up text-center p-5"
      id="sign-up"
      style={{ backgroundColor: colors.gencLightBlue }}
    >
      <h2 style={{ color: colors.gencBlue }}>Your Circles starts here</h2>
      <p style={{ color: colors.gencBlack }}>
        Sign up today and begin your circle to take care of family member's
        health
      </p>
      <MainButton onClick={() => { setIsModalVisible(true) }} style={{ height: '36px', paddingLeft: '20px', paddingRight: '20px' }} text={"Request Your Free Trail Health Box"} />
      <Modal title="Request Your Free Trail Health Box" visible={isModalVisible} onOk={() => { handleSubmit() }} onCancel={() => { setIsModalVisible(false); form.resetFields() }}>
        <Form form={form} layout="vertical">
          <Form.Item name={'name'} label="Your name" rules={[{ required: true, message: 'Your name is require' }]}>
            <Input />
          </Form.Item>
          <Form.Item name={'email'} label="Your email" rules={[{ required: true, type: 'email', message: 'Your email is invalid' }]}>
            <Input />
          </Form.Item>

          <Form.Item name={'introduction'} label="Your message">
            <Input.TextArea rows={6} />
          </Form.Item>

        </Form>
      </Modal>
    </section>
  );
};
